export default __webpack_public_path__ + "112c22ab6678e772854dd838b6922180.png";